export interface IRTMMarker {
  dayIndex: number;
  code?: RTMActiveDayCode;
}

export interface ITimeUnits {
  minutes: number;
  seconds: number;
}

export interface IUnitAnimation {
  isDone?: boolean;
}

export enum RTMTimerStatesEnum {
  active = 'Active',
  idle = 'Idle',
  missing = 'Missing monitoring event',
  inActive = 'Inactive',
}

export interface IRtmTimerState {
  color: string;
  secondaryColor: string;
  isShowStriped?: boolean;
}
export interface IRtmEvent {
  education?: string;
  meeting?: string;
}

export interface ICurrentCycle {
  countActiveDays: number;
  start: string;
  end: string;
}
export interface IBillableTime {
  currentCycle?: ICurrentCycle;
  lastRtmEvents?: IRtmEvent;
  monitorTimeInSeconds: number;
  nextMeeting?: string;
}

export enum monitoringTimeEnum {
  warning,
  done,
  inProgress,
  missing,
}
export const clinicianRTMCodes = ['98981', '98980', '98979'] as const;
export const educationRTMCodes = ['98975'] as const;
export const patientRtmCodes = ['98977', '98985'] as const;
export const clinicianMonitoringFamily = 'clinicianMonitoring' as const;
export const rtmFamilies = ['education', 'patientActivity', clinicianMonitoringFamily] as const;
export const rtmCodes = [...clinicianRTMCodes, ...patientRtmCodes, ...educationRTMCodes] as const;

export type ClinicianRTMCode = (typeof clinicianRTMCodes)[number];
export type RTMActiveDayCode = (typeof patientRtmCodes)[number];
export type RTMCode = (typeof rtmCodes)[number];
export type RTMFamily = (typeof rtmFamilies)[number];

export type EducationEventStatus = 'eventDocumented' | 'eventNotDocumented';
